window.bz_registration_module = angular.module('bzRegistrationModule', [])
